import React from "react";
import { Link } from "react-router-dom";
import Bg from "../../images/shapes/shape_net_ico_hero_section_bg.svg";
// import Logo from "../../images/site_logo/flipcoin.png";
import icon1 from "../../images/services/coin-bg.png";
const Hero = () => {
  return (
    <section
      className="ico_hero_section section_decoration text-center"
      style={{ backgroundImage: `url(${Bg})` }}
    >
      <div className="container">
        <img loading="lazy" src={icon1} alt="ICO Site Logo" />

        <div className="row justify-content-center pb-2">
          <div className="col-lg-10">
            <h1
              className="hero_title mb-3"
              data-aos="fade-up"
              data-aos-duration="800"
            >
              Welcome to TopCoin UK!
            </h1>
            <h3 className="" data-aos="fade-up" data-aos-duration="800">
              "Get Free Rewards Every Time You Shop"
            </h3>
            <p className="mb-0">
              TopCoin UK is the UK’s smartest reward and loyalty system. When
              you shop at participating businesses, you receive free TopCoin UK
              units. Collect units, unlock wallets, and get real cash rewards, no strings attached.
            </p>
            <p>
            Upon Join Today, Get £100 + 2,000 Units Instantly! Unlock your bonus as soon as you reach 22,000 units.
             {/* Upon joining, you will receive 2,000 units instantly. */}
            </p>
          </div>
        </div>

        <ul
          className="btns_group unordered_list justify-content-center mt-2 p-0"
          data-aos="fade-up"
          data-aos-duration="800"
          data-aos-delay="100"
        >
          <li>
            <Link className="ico_creative_btn" to="/sign_up">
              <span className="btn_wrapper px-5 py-3">
                <span className="btn_label">Join Now & Get Your Reward</span>
                <span className="btn_icon_right">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 24 24"
                    width="24"
                    height="24"
                    fill="currentColor"
                  >
                    <path d="M16.0037 9.41421L7.39712 18.0208L5.98291 16.6066L14.5895 8H7.00373V6H18.0037V17H16.0037V9.41421Z"></path>
                  </svg>
                </span>
              </span>
            </Link>
          </li>
        </ul>
      </div>
    </section>
  );
};

export default Hero;
